import React, {useRef, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useParams} from 'react-router'
import {useNavigate} from 'react-router-dom'
import {messageTypes, SendMessage} from 'entities/messages'
import {SendStickersAndEmoji} from 'features/sendStickersAndEmoji'
import {Button} from 'shared/ui/buttons'
import styles from './styles.module.scss'

export const ProfileChatNow = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inputEl = useRef<HTMLInputElement | null>(null)
  const {id} = useParams()
  const [value, setValue] = useState('')
  const {refetch} = SendMessage(id || '', {text: value}, messageTypes.text, dispatch)

  const chatNowHandler = () => {
    if (!value.trim()) return navigate(`/messages/${id}`)

    refetch().then(() => navigate(`/messages/${id}`))
  }

  const addEmojiHandler = (emoji: string) => {
    setValue((prev) => prev + emoji)
    inputEl.current?.focus()
  }

  const onSendStickerHandler = () => navigate(`/messages/${id}`)

  return (
    <div className={styles.wrapper}>
      <div className={styles.inputWrapper}>
        {id ?
          <SendStickersAndEmoji
            iconClassName={styles.icon}
            addEmojiHandler={addEmojiHandler}
            onSendStickerHandler={onSendStickerHandler}
            userId={id}
            classNamePopup={styles.popup}
          />
          : null}
        <input
          ref={inputEl}
          className={styles.input}
          placeholder='Start chat!'
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
      </div>

      <Button
        styleType='primary'
        className={styles.chatNow}
        onClick={chatNowHandler}
      >
        Chat now
      </Button>
    </div>
  )
}